<template>
  <div class="flex flex-col mx-8 text-white">
    <div class="flex flex-row items-end">
      <div
        class="flex flex-row items-center flex-shrink-0 w-24 h-24 p-1 bg-white rounded-lg "
      >
        <slot name="img"></slot>
      </div>
      <div
        class="ml-4 text-2xl font-light text-left uppercase"
        :style="{
          borderBottom: `2px solid ${color}`,
        }"
      >
        {{ companyName }}
      </div>
    </div>
    <div class="mt-4 text-2xl font-bold text-left">{{ position }}</div>
    <div class="text-left">
      <ul>
        <li class="flex flex-row" v-for="job in jobs" :key="job">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="flex-shrink-0 w-6 h-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 8l4 4m0 0l-4 4m4-4H9V4"
            />
          </svg>
          {{ job }}
        </li>
      </ul>
    </div>
    <div
      @click.prevent="open()"
      class="flex items-center h-8 px-2 mx-auto mt-4 font-semibold text-gray-800 bg-white rounded "
    >
      See Work at RMR
    </div>

    <transition enter-class="opacity-0" leave-to-class="opacity-0">
      <div
        v-show="showOverlay"
        class="fixed top-0 left-0 w-screen h-screen overflow-scroll transition"
        ref="overlay"
      >
        <div
          class="absolute top-0 left-0 z-10 w-full h-full bg-black opacity-50"
          @click="close()"
        />
        <transition
          @before-enter="beforeEnter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @after-leave="afterLeave"
        >
          <div
            class="absolute top-0 z-20 w-full p-4 mt-0 text-black transition-all duration-300 bg-white rounded-t-xl"
            v-show="showOverlay"
            ref="modalContent"
          >
            <div class="pb-4 text-4xl font-semibold">
              {{ companyName }}
            </div>
            <div class="flex flex-row flex-wrap justify-center mb-12">
              <div
                class="px-2 py-1 mx-1 text-sm text-white bg-green-400 rounded"
                :style="{ backgroundColor: color }"
                v-for="tech in stack"
                :key="tech"
              >
                {{ tech }}
              </div>
            </div>
            <slot @expand-screenshot="log()" />
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    color: String,
    companyName: String,
    position: String,
    jobs: Array,
    stack: Array,
  },
  data() {
    return {
      showOverlay: false,
      modalContentScrollHeight: 0,
      swipeCanClose: false,
      swipeStartHeight: 0,
    };
  },
  mounted() {
    this.$on("expand-screenshot", () => {
      this.$refs.overlay.style.overflow = "hidden";
    });
    this.$on("close-screenshot", () => {
      this.$refs.overlay.style.overflow = "scroll";
    });
  },
  methods: {
    beforeEnter(el) {
      el.style.marginTop = window.innerHeight + "px";
    },
    afterEnter(el) {
      el.style.marginTop = "20rem";
    },
    beforeLeave(el) {
      el.style.marginTop = "20rem";
    },
    afterLeave(el) {
      el.style.marginTop = window.innerHeight + "px";
    },
    open() {
      this.showOverlay = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.showOverlay = false;
      document.body.style.overflow = "auto";
    },
    openSheet() {
      this.$refs.mySheet.open();
    },
    handleScroll(event) {
      if (event.target === this.$refs.overlay) {
        // console.log("TEST");
        //   if (this.$refs.modalContent.getBoundingClientRect().top === 0) {
        //     this.$refs.modalContent.style.overflow = "scroll";
        //     this.$refs.modalContent.scrollTop = 1;
        //     this.$refs.modalContent.classList.remove("rounded-t-xl");
        //   }
        // } else if (
        //   event.target === this.$refs.modalContent &&
        //   this.$refs.modalContent.getBoundingClientRect().top ===
        //     parseInt(window.getComputedStyle(this.$refs.modalContent).marginTop)
        // ) {
        //   this.$refs.modalContent.style.overflow = "hidden";
        //   this.$refs.modalContent.classList.add("rounded-t-xl");
      }
    },
    log() {
      console.log("test");
    },
  },
};
</script>

<style scoped>
.mt-full {
  margin-top: 100%;
}
</style>
